var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.997,
    height: 54.002,
    viewBox: "0 0 53.997 54.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13467.463 22387a1.958 1.958 0 01-1.961-1.955 1.865 1.865 0 01.314-1.057l5.265-8.557a1.96 1.96 0 013.349.016l5.275 8.574a1.839 1.839 0 01.293 1.023 1.958 1.958 0 01-1.961 1.955zm4.287-3a1 1 0 101-1 1 1 0 00-1 1zm0-4.5v2a1 1 0 002 0v-2a1 1 0 00-2 0zm-13 4.5a2.749 2.749 0 01-2.748-2.754v-15.5a2.749 2.749 0 012.748-2.752h11.5a2.75 2.75 0 012.753 2.752v6.76a1.878 1.878 0 00-.253-.012 3.921 3.921 0 00-3.371 1.889l-5.22 8.482a3.711 3.711 0 00-.511 1.131zm.253-8a1 1 0 001 1h5a1 1 0 000-2h-5a1 1 0 00-1.003 1zm0-4a1 1 0 001 1h9a1 1 0 000-2h-9a1 1 0 00-1.003 1zm0-4a1 1 0 001 1h4a1 1 0 000-2h-4a1 1 0 00-1.003 1z",
    "data-name": "Union 6",
    transform: "translate(-13441 -22351)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.49cbd5b523c9be6ea4dabc66a8b5c341.svg";
export { ForwardRef as ReactComponent };